import environment from '../config/environment';

const RECAPTCHA_SCRIPT_ID = 'recaptcha-script';
const RECAPTCHA_FUNCTION = 'grecaptcha';
const BADGE_POSITION = 'bottomleft';

/**
 * Loads the Google reCAPTCHA script.
 *
 * This function loads the reCAPTCHA script if not already loaded.
 */
export const loadReCaptchaScript = () => {
  const existingScript = document.getElementById(RECAPTCHA_SCRIPT_ID);
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${environment.RECAPTCHA_SITE_KEY}&badge=${BADGE_POSITION}`;
    script.id = RECAPTCHA_SCRIPT_ID;
    script.async = true;
    document.body.appendChild(script);
  }
};

/**
 * Retrieves the reCAPTCHA token.
 *
 * This asynchronous function returns a Promise that resolves with a reCAPTCHA token.
 * If the reCAPTCHA function is not available or encounters an error,
 * the Promise is rejected with an error.
 *
 * @param {string} action - The action parameter to execute reCAPTCHA.
 * @returns {Promise<string>} - A Promise that resolves with the reCAPTCHA token.
 */
export const getReCaptchaToken = async (action: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (typeof window[RECAPTCHA_FUNCTION as keyof Window] === 'object') {
      const grecaptcha = window[RECAPTCHA_FUNCTION as keyof Window];
      grecaptcha.ready(() => {
        grecaptcha
          .execute(environment.RECAPTCHA_SITE_KEY, { action })
          .then((token: string) => {
            resolve(token);
          })
          .catch((error: unknown) => {
            reject(error);
          });
      });
    } else {
      reject(new Error('reCAPTCHA not loaded'));
    }
  });
};
